import { AbiItem } from 'web3-utils';

export const outboxAbi: AbiItem[] = [
    {
        inputs: [
            { internalType: 'bytes32[]', name: 'proof', type: 'bytes32[]' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
            { internalType: 'address', name: 'l2Sender', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'l2Block', type: 'uint256' },
            { internalType: 'uint256', name: 'l1Block', type: 'uint256' },
            { internalType: 'uint256', name: 'l2Timestamp', type: 'uint256' },
            { internalType: 'uint256', name: 'value', type: 'uint256' },
            { internalType: 'bytes', name: 'data', type: 'bytes' }
        ],
        name: 'executeTransaction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    }
];
